// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__rVQKD","iconContainer":"Footer_iconContainer__kRBY-","icon":"Footer_icon__S1RTh","copyRight":"Footer_copyRight__AfqR9"};